import { postImplementImage } from "src/scripts/mixin";
import { accordianClickEvent } from "src/components/accordian/accordian";

export default () => {
    
    postImplementImage(false, 1111);
    accordianClickEvent();
    
}